(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@cainiaofe/cn-ui-m"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@cainiaofe/cn-ui-m"], factory);
	else if(typeof exports === 'object')
		exports["cn-ui-m-lowcode"] = factory(require("react"), require("@cainiaofe/cn-ui-m"));
	else
		root["cn-ui-m-lowcode"] = factory(root["React"], root["CNUIM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 